import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  packagingControllerCreate,
  PackagingControllerCreate$Params,
  packagingControllerDelete,
  packagingControllerFindAll,
  PackagingControllerFindAll$Params,
  packagingControllerFindById,
  packagingControllerUpdate,
  PackagingControllerUpdate$Params,
} from '@klubovna/api-client';
import { CreatePackagingTypeDto, PackagingType, UpdatePackagingTypeDto } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PackagingTypesApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: PackagingControllerFindAll$Params): Observable<PaginatedResponse<PackagingType>> {
    return packagingControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<PackagingType>(response.body)));
  }

  findById(id: string): Observable<PackagingType> {
    return packagingControllerFindById(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as PackagingType));
  }

  create(data: CreatePackagingTypeDto): Observable<PackagingType> {
    const params: PackagingControllerCreate$Params = { body: data };
    return packagingControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as PackagingType));
  }

  update(id: string, data: UpdatePackagingTypeDto): Observable<PackagingType> {
    const params: PackagingControllerUpdate$Params = { id, body: data };
    return packagingControllerUpdate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as PackagingType));
  }

  delete(id: string): Observable<void> {
    return packagingControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}
